import type React from "react";
import { BaseComposeInput } from "@/components/common/BaseComposeInput";
import type { BaseInputEditorVisibilityProps } from "@/components/common/BaseInputEditor";
import { COMMENT_MAX_FILE_SIZE, COMMENT_MAX_LENGTH } from "@/constants";
import type { User } from "@/lib/humhub-api/types";

interface BaseCommentInputProps extends BaseInputEditorVisibilityProps {
  placeholder?: string;
  submitButtonLabel?: string;
  showFormatting?: boolean;
  onSubmit?: (content: string, files?: File[]) => Promise<void>;
  className?: string;
  disabled?: boolean;
  maxFileSize?: number;
  allowedFileTypes?: string[];
  mentionUsers?: User[];
  isLoadingMentionUsers?: boolean;
  onMentionTrigger?: (query: string) => Promise<User[]>;
  mentionScopeKey?: string;
  autoFocus?: boolean;
}

export const BaseCommentInput: React.FC<BaseCommentInputProps> = ({
  placeholder,
  submitButtonLabel,
  showFormatting = true,
  onSubmit,
  className = "",
  disabled,
  maxFileSize = COMMENT_MAX_FILE_SIZE,
  allowedFileTypes,
  mentionUsers = [],
  isLoadingMentionUsers = false,
  onMentionTrigger,
  mentionScopeKey,
  autoFocus = false,
  alwaysVisible = true, // Default to true as per user request for comments/replies
}) => {
  return (
    <BaseComposeInput
      placeholder={placeholder}
      submitButtonLabel={submitButtonLabel}
      showFormatting={showFormatting}
      onSubmit={onSubmit}
      className={className}
      disabled={disabled}
      maxFileSize={maxFileSize}
      maxLength={COMMENT_MAX_LENGTH}
      allowedFileTypes={allowedFileTypes}
      onMentionTrigger={onMentionTrigger}
      mentionScopeKey={mentionScopeKey}
      mentionUsers={mentionUsers}
      isLoadingMentionUsers={isLoadingMentionUsers}
      autoFocus={autoFocus}
      alwaysVisible={alwaysVisible}
      context="post"
    />
  );
};
